import React, { FC, useCallback } from 'react'
import moment from 'moment'
import { IFilterInputProps } from 'apps/fleet-planner/pages/loads/FilterFacilityLocation'
import { ILoadFilters } from 'apps/fleet-planner/types'
import { DatePicker } from 'components/forms'
import { FORMATS } from 'constants/datetime'

export interface IFilterDateProps
  extends IFilterInputProps<Partial<Pick<ILoadFilters, 'dropoffDate'>>> {}

export const FilterDropoffDate: FC<IFilterDateProps> = ({
  dataTest = 'loads-filter-do-date',
  id,
  label = 'Dropoff Date',
  onChange: onChangeProp,
  placeholder = 'mm/dd/yyyy',
  value: valueProp,
}) => {
  const changeHandler = useCallback(
    ([selected]: string[]) => {
      const dropoffDate = selected ? moment(selected).format(FORMATS.yearFirst) : undefined
      if (dropoffDate !== valueProp?.dropoffDate) {
        onChangeProp({ dropoffDate })
      }
    },
    [onChangeProp, valueProp?.dropoffDate]
  )

  const { dropoffDate } = valueProp || {}

  return (
    <>
      <label className='label' htmlFor={id}>
        {label}
      </label>
      <DatePicker
        large
        id={id}
        placeholder={placeholder}
        onDateChange={changeHandler}
        date={dropoffDate}
        dataTest={dataTest}
      />
    </>
  )
}
